import React, { useRef } from "react";
import { Formik, Form, Field } from "formik";
import { Row, Col, Collapse, Alert } from "reactstrap";

import { useDispatch, useSelector } from "react-redux";
import { Select } from "../../../../components/formik";

import { ButtonWithSpinner } from "../../../../components/common";

import { watchListMultipleSearchValidationSchema } from "../../validation-schemas";
import { optionsType } from "../../../../prop-types";
import { FILTER_LABELS_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES } from "../../constants/watchListEntryConstants";

import {
  watchListMultipleSearchEntriesFiltersSelector,
  watchListMultipleSearchEntriesLoadingSelector,
} from "../../selectors";
import { CollapseButton, CollapseOpenIcon } from "../../../../assets";
import Clickable from "../../../../components/common/Clickable";
import "./searchWatchListMultipleEntries.css";
import {
  setWatchListEntriesMultipleSearchFilters,
  getWatchListMultipleSearchEntries,
} from "../../actions";
import { FaTimes } from "react-icons/fa";
import WatchListTypeButtons from "../../../../components/formik/watchListType/WatchListTypeButtons";
import FiltersFileUpload from "./filtersFileUpload/FiltersFileUpload";
import { shouldShowFiltersLabelsMultipleSearchWatchList } from "../../../../utilities/filters";
import Hint from "./hint/Hint";

const percentageOptions = [
  { value: 95, label: "95" },
  { value: 100, label: "100" },
];

const SearchWatchListMultipleEntries = ({
  nationalities = [],
  isOpenCollapse,
  toggleCollapse,
  watchListMultipleEntries,
}) => {
  const FILTERS_TEMPLATE = {
    minimumMatchingPercentage: null,
    watchListTypes: [],
    file: null,
  };
  const watchListTypes = [
    { value: "PEP", label: "PEP" },
    { value: "MWP", label: "MWP" },
    { value: "BLK", label: "BLK" },
    { value: "SAN", label: "SAN" },
    { value: "TERR", label: "TERR" },
    { value: "PEPRELATED", label: "PEPR" },
    // { value: "ADV", label: "ADV" },
    // { value: "HRC", label: "HRC" },
    { value: "YWL", label: "YWL" },
    { value: "ALL", label: "ALL" },
  ];

  const FILE_TYPES = {
    "text/csv": [".csv"],
  };

  const dispatch = useDispatch();
  const filters = useSelector(watchListMultipleSearchEntriesFiltersSelector);

  const formikRef = useRef(null);

  const isLoading = useSelector(watchListMultipleSearchEntriesLoadingSelector);

  const handleSubmit = (data) => {
    dispatch(setWatchListEntriesMultipleSearchFilters(data));
    dispatch(getWatchListMultipleSearchEntries());
    toggleCollapse();
  };

  function clearFilters() {
    dispatch(setWatchListEntriesMultipleSearchFilters(FILTERS_TEMPLATE));

    formikRef.current.setValues(FILTERS_TEMPLATE);

    formikRef.current.resetForm();

    toggleCollapse();
  }

  return (
    <div>
      <Formik
        ref={formikRef}
        onSubmit={handleSubmit}
        initialValues={FILTERS_TEMPLATE}
        validationSchema={watchListMultipleSearchValidationSchema}
        validateOnBlur={false}
        validateOnChange={false}
        enableReinitialize
      >
        {(props) => {
          const { errors } = props;
          return (
            <div>
              <div className="watch-list-collapse-search">
                <Collapse isOpen={isOpenCollapse}>
                  <Form className=" watch-list-search">
                    <div className="watch-list-search-inner-container ">
                      <Row className="d-flex justify-content-center mb-3">
                        <Col lg={3}>
                          <Field
                            name="minimumMatchingPercentage"
                            placeholder="Matching Percentage"
                            className="dropdown-group"
                            isClearable
                            component={Select}
                            options={percentageOptions}
                          />
                        </Col>
                      </Row>
                      <Row className="d-flex justify-content-center">
                        <Col lg={3}>
                          <Field
                            name="file"
                            component={FiltersFileUpload}
                            key={Date.now()}
                            accept={FILE_TYPES}
                          />
                        </Col>
                      </Row>
                      <Row className="d-flex justify-content-center">
                        <Col lg={8}>
                          <Field
                            name="watchListTypes"
                            label="Watchlist Type: "
                            className="dropdown-group"
                            isClearable
                            component={WatchListTypeButtons}
                            options={watchListTypes}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={12}
                          className="d-flex justify-content-center flex-column  pt-2"
                        >
                          <p className="p-0 m-0 form-error-message d-flex justify-content-center m-0">
                            {errors.minimumMatchingPercentage
                              ? errors.minimumMatchingPercentage
                              : null}
                            {errors.file ? errors.file : null}
                            {errors.watchListTypes
                              ? errors.watchListTypes
                              : null}
                          </p>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={8}
                          className="m-auto d-flex justify-content-center"
                        >
                          <Hint>
                            <Alert color="dark">
                              <i>
                                (Type) Person - <b>required:</b> FirstName,
                                MiddleName, LastName | <b>optional:</b>{" "}
                                Nationality, BirthDate
                              </i>
                              <hr />
                              <i>
                                (Type) Company - <b>required:</b> FullName |{" "}
                                <b>optional:</b> Nationality, BirthDate
                              </i>
                            </Alert>
                          </Hint>
                        </Col>
                      </Row>
                      <Row>
                        <Col
                          lg={12}
                          className="d-flex justify-content-center pt-2"
                        >
                          <ButtonWithSpinner
                            text="Search"
                            outline
                            type="submit"
                            className=" search-button-watch-list"
                            loading={isLoading}
                          />
                        </Col>
                      </Row>
                    </div>
                  </Form>
                  <div
                    style={{ marginTop: -6 }}
                    className="watch-list-filters-menu-collapse-button"
                  >
                    {watchListMultipleEntries.length ? (
                      <Clickable onClick={toggleCollapse}>
                        <CollapseButton />
                      </Clickable>
                    ) : null}
                  </div>
                </Collapse>
              </div>
              <div
                style={{ marginTop: -6 }}
                className="watch-list-filters-menu-collapse-button"
              >
                <Clickable onClick={toggleCollapse}>
                  {!isOpenCollapse ? <CollapseOpenIcon /> : null}
                </Clickable>
              </div>
              <div className="watch-list-filters-main-container">
                <Row>
                  <Col lg={10}>
                    <div className="single-filters-container">
                      {shouldShowFiltersLabelsMultipleSearchWatchList(
                        filters
                      ) ? (
                        <div className="filters-menu-label">Filter Applied</div>
                      ) : null}

                      {Object.entries(filters).map(([key, value], i) => {
                        return value ? (
                          <SingleFilter
                            key={`${key}-${i}`}
                            filterKey={key}
                            filterValue={value}
                            clearFilter={() => clearSingleFilter(key)}
                          />
                        ) : null;
                      })}

                      {shouldShowFiltersLabelsMultipleSearchWatchList(
                        filters
                      ) ? (
                        <div
                          onClick={clearFilters}
                          className="filters-menu-label-clear"
                        >
                          Clear All
                        </div>
                      ) : null}
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          );
        }}
      </Formik>
    </div>
  );

  function clearSingleFilter(filterKey) {
    let val = null;
    const currentFilters = { ...filters };

    dispatch(
      setWatchListEntriesMultipleSearchFilters({
        [filterKey]: val,
      })
    );

    currentFilters[filterKey] = val;

    formikRef.current.setFieldValue(filterKey, FILTERS_TEMPLATE[filterKey]);

    if (filters.minimumMatchingPercentage && filters.file) {
      dispatch(getWatchListMultipleSearchEntries());
    }
  }

  function SingleFilter({
    filterKey = "",
    filterValue = "",
    clearFilter = () => {},
  }) {
    if (Array.isArray(filterValue) && !filterValue.length) {
      return null;
    }
    let currentValue = filterValue;
    if (filterKey === "file" && currentValue) {
      currentValue = filterValue.name;
    }

    if (filterKey === "nationalityId" && filterValue) {
      if (nationalities.length) {
        const label = nationalities.find(
          (nat) => parseInt(nat.value, 10) === parseInt(filterValue, 10)
        ).label;

        currentValue = label;
      }
    }

    return (
      <div className="single-filter-box">
        <div className="single-filter-label">
          {FILTER_LABELS_WATCH_LIST_MULTIPLE_SEARCH_ENTRIES[filterKey]}
        </div>
        <div className="single-filter-chip">
          {filterKey === "watchListTypes"
            ? currentValue.join(", ")
            : currentValue}
          {filterKey === "watchListTypes" ? (
            <FaTimes
              className="remove-filter-icon"
              onClick={clearFilter}
              color="#707070"
            />
          ) : null}
        </div>
      </div>
    );
  }
};

SearchWatchListMultipleEntries.propTypes = {
  isOpenCollapse: optionsType.isRequired,
  toggleCollapse: optionsType.isRequired,
  watchListMultipleEntries: optionsType.isRequired,
};
export default SearchWatchListMultipleEntries;



// WEBPACK FOOTER //
// ./src/features/watch-list-entry/components/search-watch-list-multiple-entries/SearchWatchListMultipleEntries.jsx